import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "blue-bg-text ion-text-center"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "blue-bg-text"
}
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_slides = _resolveComponent("slides")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ClientActionCardList = _resolveComponent("ClientActionCardList")!
  const _component_UniStudentActionCardList = _resolveComponent("UniStudentActionCardList")!
  const _component_TeacherActionCardList = _resolveComponent("TeacherActionCardList")!
  const _component_SecStudentActionCardList = _resolveComponent("SecStudentActionCardList")!
  const _component_FDMTStaffActionCardList = _resolveComponent("FDMTStaffActionCardList")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, { selectedView: $setup.selectedView }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            class: "view-switcher-toolbar",
            style: {"--min-height":"40px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment, {
                class: "view-switcher",
                mode: "ios",
                modelValue: $setup.selectedView,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedView) = $event)),
                scrollable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment_button, {
                    value: "home",
                    style: {"--padding-start":"0","--padding-end":"0","min-width":"36px","width":"min-content"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        size: "small",
                        icon: $setup.home
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  (!$setup.isSecondaryStudent)
                    ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                        key: 0,
                        value: "university-client"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode("University staff")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!$setup.isSecondaryStudent)
                    ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                        key: 1,
                        value: "university-student"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("University student")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!$setup.isSecondaryStudent)
                    ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                        key: 2,
                        value: "teacher"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("Teacher / Principal")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_segment_button, {
                    value: "secondary-school-student",
                    disabled: $setup.user.id && !$setup.user.teacher && !$setup.user.isSecondaryStudent && !$setup.user.isAdmin
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("Secondary student")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  ($setup.isFDMTStaff)
                    ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                        key: 3,
                        value: "fdmt-staff"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("FDMT staff")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!$setup.isSecondaryStudent)
                    ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                        key: 4,
                        value: "practitioner",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("Practitioner")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selectedView"]),
      _createVNode(_component_ion_content, {
        style: {"--padding-bottom":"100px"},
        fullscreen: true,
        "scroll-events": true,
        onIonScroll: $setup.handleScroll
      }, {
        default: _withCtx(() => [
          ($setup.selectedView == 'home')
            ? (_openBlock(), _createBlock(_component_slides, {
                key: 0,
                homeBanners: true
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              ($setup.user.isUniversityClient && (!$setup.user.clientId || $setup.user.clientId == 'To be assigned'))
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 0,
                    class: "ion-margin-vertical",
                    color: "light",
                    lines: "full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.alertCircle,
                        color: "danger"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createElementVNode("h3", null, "Thank you for your registration. We will soon verify your identity and unlock below sections for you.", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.ackAppliedEvent)
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 1,
                    class: "ion-margin-vertical",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickWhatsAppButton())),
                    color: "light",
                    lines: "full",
                    target: "_blank",
                    href: $setup.user.waGroupLink,
                    button: "",
                    detail: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        size: "large",
                        slot: "start",
                        icon: $setup.checkmarkCircle,
                        color: "success",
                        style: {"padding":"16px"}
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, [
                            _cache[15] || (_cache[15] = _createTextVNode("Thank you for applying for ")),
                            _createElementVNode("b", null, _toDisplayString($setup.ackAppliedEvent.name) + " (" + _toDisplayString($setup.ackAppliedEvent.formattedDateTime) + ")", 1),
                            _cache[16] || (_cache[16] = _createTextVNode("!"))
                          ]),
                          _cache[17] || (_cache[17] = _createElementVNode("p", null, "Please click here to join the WhatsApp group assigned to you. We will keep you updated on the event via WhatsApp.", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href"]))
                : ($setup.ackInterestedService)
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 2,
                      class: "ion-margin-vertical",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickWhatsAppButton())),
                      color: "light",
                      lines: "full",
                      target: "_blank",
                      href: $setup.user.waGroupLink,
                      button: "",
                      detail: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          size: "large",
                          slot: "start",
                          icon: $setup.checkmarkCircle,
                          color: "success",
                          style: {"padding":"16px"}
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, [
                              _cache[18] || (_cache[18] = _createTextVNode("Thank you for your interest in ")),
                              _createElementVNode("b", null, _toDisplayString($setup.ackInterestedService?.name), 1),
                              _cache[19] || (_cache[19] = _createTextVNode("!"))
                            ]),
                            _cache[20] || (_cache[20] = _createElementVNode("p", null, "Please click here to join the WhatsApp group assigned to you and receive our support.", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  : ($setup.user.waGroupLink && $setup.user.userInWaGroup != true)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 3,
                        class: "ion-margin-vertical",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onClickWhatsAppButton())),
                        color: "light",
                        lines: "full",
                        target: "_blank",
                        href: $setup.user.waGroupLink,
                        button: "",
                        detail: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: $setup.alertCircle,
                            color: "danger"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createElementVNode("h3", null, "To continue using this app, please click here to join the WhatsApp group assigned to you.", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["href"]))
                    : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass({ 'disabled': ($setup.user.waGroupLink && $setup.user.userInWaGroup != true) })
              }, [
                ($setup.forceReload || $setup.loadingData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_ion_spinner)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      ($setup.selectedView == 'home')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[22] || (_cache[22] = [
                            _createElementVNode("iframe", {
                              src: "https://docs.google.com/presentation/d/e/2PACX-1vSlzoW3oyvKSKNtMs-IR4NYJW47p0UuDOYgULRhfPrAkYKdmgB_urEX8ENeQlgxh-G0_D32N0E9f8Sf/embed?start=false&loop=false&delayms=3000&rm=demo&chrome=false",
                              frameborder: "0",
                              style: {"width":"100%","height":"calc(min(100vw, 1000px) * 0.8)"},
                              allowfullscreen: "true",
                              mozallowfullscreen: "true",
                              webkitallowfullscreen: "true"
                            }, null, -1),
                            _createElementVNode("div", {
                              style: {"background-image":"url('https://fdmt.hk/imgproxy.php?url=https%3A%2F%2Fdocs.google.com%2Fpresentation%2Fd%2F1VLGNeYi1mHB-EZGbUxQG0Bz_vwPQ4dpDgn65HJkUyzo%2Fexport%2Fjpeg%3Fid%3D1VLGNeYi1mHB-EZGbUxQG0Bz_vwPQ4dpDgn65HJkUyzo%26pageid%3Dg2b9bc6ceeec_0_29')"},
                              class: "half-image"
                            }, null, -1),
                            _createElementVNode("iframe", {
                              src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.9983305383935!2d114.18265047604451!3d22.278053079702527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34040141c65fa42b%3A0x2402f0da20af3149!2sFDMT%20Consulting!5e0!3m2!1sen!2shk!4v1731731923484!5m2!1sen!2shk",
                              width: "100%",
                              style: {"border":"0","height":"240px"},
                              allowfullscreen: "",
                              loading: "lazy"
                            }, null, -1),
                            _createElementVNode("p", {
                              id: "copyright",
                              class: "ion-text-center",
                              style: {"color":"#fff"}
                            }, [
                              _createElementVNode("small", null, [
                                _createTextVNode(" Copyright © 2002 - 2024 Fundamentum Limited. All Rights Reserved | "),
                                _createElementVNode("a", {
                                  href: "https://www.fdmt.hk/legal",
                                  target: "_blank"
                                }, "Privacy statement"),
                                _createTextVNode(" | "),
                                _createElementVNode("a", {
                                  href: "https://www.fdmt.hk/legal",
                                  target: "_blank"
                                }, "Site terms"),
                                _createTextVNode(" | "),
                                _createElementVNode("a", {
                                  href: "https://www.fdmt.hk/legal",
                                  target: "_blank"
                                }, "Disclaimer")
                              ])
                            ], -1)
                          ])))
                        : _createCommentVNode("", true),
                      ($setup.selectedView == 'university-client')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (!$setup.user.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createVNode(_component_ion_button, {
                                    class: "no-text-transform",
                                    expand: "block",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openLoginModal('university-client')))
                                  }, {
                                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                                      _createTextVNode(" Enter (for registered clients)"),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode("or Register (for new clients) ")
                                    ])),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (!$setup.user.isUniversityClient)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[24] || (_cache[24] = [
                                  _createElementVNode("iframe", {
                                    src: "https://docs.google.com/presentation/d/e/2PACX-1vRCpCEuSU4lh6A-ydSUE6-CpaUoGJhoKJrkK-Zg0vTv3WtgcCo7P-ORRrjLMuTcCP8Z326oCZr1oosN/embed?start=false&loop=true&delayms=3000&rm=demo&chrome=false",
                                    frameborder: "0",
                                    style: {"width":"100%","height":"calc(min(100vw, 1000px) * 0.8)"},
                                    allowfullscreen: "true",
                                    mozallowfullscreen: "true",
                                    webkitallowfullscreen: "true"
                                  }, null, -1)
                                ])))
                              : _createCommentVNode("", true),
                            ($setup.user.isUniversityClient)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(_component_ClientActionCardList)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.selectedView == 'university-student')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            ($setup.user.isUniversityClient || $setup.user.isUniversityStudent)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createVNode(_component_UniStudentActionCardList)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createVNode(_component_ion_button, {
                                    class: "ion-margin-bottom no-text-transform ion-text-wrap",
                                    expand: "block",
                                    href: "https://bluebird.fdmt.hk",
                                    target: "_blank"
                                  }, {
                                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                                      _createTextVNode(" Bluebird: Internship (employed by FDMT) for UG year 1 & year 2, MPhil & PhD students ")
                                    ])),
                                    _: 1
                                  }),
                                  (!$setup.user.id)
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        class: "no-text-transform ion-text-wrap",
                                        expand: "block",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openLoginModal('university-student')))
                                      }, {
                                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                                          _createTextVNode(" AchieveBot: AI-powered job hunting support for students from our client department ")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]))
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.selectedView == 'teacher')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            ($setup.user.teacher)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_TeacherActionCardList, { prefilledViewType: $setup.prefilledViewType }, null, 8, ["prefilledViewType"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (!$setup.user.id)
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        class: "no-text-transform",
                                        expand: "block",
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openLoginModal('teacher')))
                                      }, {
                                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                                          _createTextVNode(" Enter (for registered teachers)"),
                                          _createElementVNode("br", null, null, -1),
                                          _createTextVNode("or Register (for new teachers) ")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _cache[28] || (_cache[28] = _createElementVNode("iframe", {
                                    src: "https://docs.google.com/presentation/d/e/2PACX-1vRYQdqNzqkYi6HV4IJejx3WFNLrVdUAFqtmoXww_DNvwIFEtOimo_ly4vYIzqqfB-ebaph8BS0DMuD_/embed?start=false&loop=false&delayms=3000",
                                    frameborder: "0",
                                    style: {"width":"100%","height":"calc(min(100vw, 1000px) * 0.8)"},
                                    allowfullscreen: "true",
                                    mozallowfullscreen: "true",
                                    webkitallowfullscreen: "true"
                                  }, null, -1))
                                ]))
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.selectedView == 'secondary-school-student')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (!$setup.user.id)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  class: "no-text-transform ion-text-wrap",
                                  expand: "block",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openLoginModal('secondary-school-student')))
                                }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createTextVNode(" Enter (for registered students)"),
                                    _createElementVNode("br", null, null, -1),
                                    _createTextVNode("or Register (for new students) ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            ($setup.user.teacher || $setup.user.isSecondaryStudent)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_SecStudentActionCardList)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.selectedView == 'fdmt-staff' && $setup.isFDMTStaff)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_FDMTStaffActionCardList)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}